import axios from 'axios'

export default {
  data: () => ({ numberAccessLoading: false, numberAccessAllowed: false, numberAccessError: '', numberBillingRequired: false }),
  methods: {
    async checkNumberAccess() {
      this.numberAccessLoading = true
      this.numberAccessAllowed = false
      this.numberAccessError = ''; this.numberBillingRequired = false
      try {
        const { data } = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/agency/access-status`, {
          headers: { Authorization: 'Bearer ' + this.$store.state.auth.jwt }, timeout: 30000
        })
        this.numberAccessAllowed = data.can_purchase_numbers === undefined ? !data.pending : data.can_purchase_numbers
        this.numberBillingRequired = data.number_billing_required === true
        if (!this.numberAccessAllowed) {
          this.numberAccessError = data.number_purchase_message || 'This account requires approval before purchasing numbers.'
        }
      } catch (e) {
        this.numberAccessError = 'Unable to check phone number access. Close this dialog and try again.'
      } finally {
        this.numberAccessLoading = false
      }
      return this.numberAccessAllowed
    }
  }
}
